module.exports = {
  ALTER_DEPARTURE_FLIGHT_OVERVIEW_LISTENER: 'alter-departure-flight-overview',
  ALTER_RETURN_FLIGHT_OVERVIEW_LISTENER: 'alter-return-flight-overview',
  CALCULATE_POINTS_LISTENER: 'calculate-points',
  CLEAR_OVERVIEW_LISTENER: 'clear-overview',
  UPDATE_QUOTATION_JOURNEY: 'update-quotation-journey',
  VALIDATE_FIELD_LISTENER: 'validate-field',
  UPDATE_HEADER: 'update-header',
  RECENT_FLIGHTS: 'recent-flights',
  SEND_ANALYTICS_TAG: 'send-analytics-tag',
  LOADED_AVAILABILITY: 'loaded-availability',
  REFRESH_TOKEN_CALLCENTER: 'refresh-token-callcenter',
  SHOW_MODAL_INACTIVITY: 'show-modal-inactivity',
  LIST_CHANGE_FILTER: 'list-change-filter'
};



// WEBPACK FOOTER //
// ./src/const/Listener.js